let env = process.env.VUE_APP_MODE;

if (window.location.href.includes('app.soulapp.cn')) {
  env = 'production';
}

const protocol = window.location.protocol || 'http:';
export const baseUrl =
  env === "production"
    ? "https://marketing-openapi.soulapp.cn"
    : env === "pre"
      ? `${protocol}//pre-marketing-openapi.soulapp-inc.cn`
      : `${protocol}//marketing-openapi-ct.soulapp-inc.cn`;

export const discernUrl =
  env === "production"
    ? "https://dicern-biz-code.soulapp.cn"
    : env === "pre"
      ? `${protocol}//pre-discern-biz-code.soulapp-inc.cn`
      : `${protocol}//discern-code-openapi-ct.soulapp-inc.cn`;
